// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"0507470b","323":"4b02e5f5","550":"1a3535e6","626":"ca59471f","668":"34fb1e43","707":"7301de1b","791":"cb7c2b07","796":"2f39654b","878":"db8ff727","891":"b84fcb97"}[chunkId] + ".chunk.css";
};